import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const useUrlQuery = () => {
  const location = useLocation();

  const urlSearchParams = useMemo(() => {
    const search = location.search;
    return new URLSearchParams(search);
  }, [location.search]);

  return urlSearchParams;
};
